import LigthBox from "../components/Lightbox";

export default class PageSingle {
  constructor(data) {
    this.data = data;
    this.lightbox = new LigthBox();
  }

  init() {
    this.init_search_form();
    this.init_swiper_title_galleries();
  }

  init_search_form() {
    const form = document.querySelector(".js-search-form");
    const input_wrap = form?.querySelector(".single-input-wrap");
    const input = form?.querySelector("#search");
    
    form?.addEventListener("submit", (e) => {
      if (!input.value.length > 0) {
        e.preventDefault();
        !input_wrap?.classList.contains("has-error")
          && input_wrap.classList.add("has-error");
      }
    });

    input?.addEventListener("input", (e) => {
      if (input.value.length > 0) {
        input_wrap?.classList.remove("has-error");
      }
    });
  }

  init_swiper_title_galleries() {
    const galleries = document.querySelectorAll(".js-swiper-title-gallery");
    galleries?.forEach((gallery) => {
      const swiper = new Swiper(gallery, {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3
          }
        },
      });
    });
  }
}